'use client';

import { c as _c } from "react/compiler-runtime";
import './nav-block.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import type { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { useListArticlesQuery } from '@sola/skippy-search-sdk/lib/queries.ts';
import type { PublishedEntryResponseDto } from '@sola/skippy-search-sdk/lib/schema.ts';
import { NavCardSkeleton } from '../nav-card/nav-card-skeleton.tsx';
import { NavCard } from '../nav-card/nav-card.tsx';
type NavBlockItemsProps = {
  featuredArticles: true;
  items?: never;
} | {
  featuredArticles?: never;
  items: FlexibleContentProps[];
};
type NavBlockProps = NavBlockItemsProps & {
  title?: string;
  maxItems?: number;
};
const toNavCardProps = (item: PublishedEntryResponseDto, linkText: string): FlexibleContentProps => ({
  title: item.pageTitle || undefined,
  body: item.summary ? <p>{item.summary}</p> : undefined,
  media: item.media ? {
    image: {
      url: item.media.image?.url || '',
      alt: item.media.image?.alt || '',
      height: 96,
      width: 70
    }
  } : undefined,
  primaryCTA: item.path ? {
    title: linkText,
    link: item.path
  } : undefined
});
const FeaturedArticlesContent = t0 => {
  const $ = _c(11);
  const {
    maxItems: t1
  } = t0;
  const maxItems = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["articles"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  let t3;
  if ($[1] !== maxItems) {
    t3 = {
      promoted: true,
      perPage: maxItems,
      sort: "datePublished",
      sortDir: "desc"
    };
    $[1] = maxItems;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data,
    isLoading
  } = useListArticlesQuery(t3);
  if (isLoading) {
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <NavCardSkeleton />;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  if (!data?.items?.length) {
    return null;
  }
  let t4;
  if ($[4] !== data.items || $[5] !== t) {
    let t5;
    if ($[7] !== t) {
      t5 = item => <NavCard key={item.contentfulEntryID} {...toNavCardProps(item, t("articles:readMore"))} featured={true} />;
      $[7] = t;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = data.items.map(t5);
    $[4] = data.items;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="NavBlock__featuredArticles flex flex-col lg:gap-snug-xl items-start">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export const NavBlock: React.FC<NavBlockProps> = props => {
  const $ = _c(16);
  const {
    title,
    maxItems
  } = props;
  if ("items" in props && props.items) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = cn("NavBlock");
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== title) {
      t1 = title && <span className="NavBlock__title label label-lg label-potent">{title}</span>;
      $[1] = title;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== props.items) {
      t2 = props.items.map(_temp);
      $[3] = props.items;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
      t3 = <div className={t0}>{t1}{t2}</div>;
      $[5] = t1;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t0;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("NavBlock");
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  let t1;
  if ($[9] !== title) {
    t1 = title && <span className="NavBlock__title label label-lg label-potent">{title}</span>;
    $[9] = title;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== maxItems) {
    t2 = <FeaturedArticlesContent maxItems={maxItems} />;
    $[11] = maxItems;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1 || $[14] !== t2) {
    t3 = <div className={t0}>{t1}{t2}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
function _temp(item, idx) {
  return <NavCard key={item.title || idx} {...item} />;
}